import { IGetReajusteByIdUseCase } from "../../../presentation/useCases/read/get_reajuste_by_id_use_case";
import { Reajuste } from "../../models/reajuste";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetReajusteByIdUseCase
 */

export class GetReajusteByIdUseCase implements IGetReajusteByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getReajusteById(idReajuste: number): Promise<Reajuste | null> {
    return await this.repository.getReajusteById(idReajuste);

  }
}
